// Lightweight, per-browser editor preferences (localStorage-backed).
// The editor reads these on mount; Settings writes them. Navigating between
// the Settings and Editor routes remounts the editor, so no reactive store
// is needed for changes to take effect.

const MINIMAP_KEY = 'ss:editor-minimap';
const GRID_KEY = 'ss:editor-grid';
const SNAP_KEY = 'ss:editor-snap';

/** Whether the editor minimap is shown. Defaults to true. */
export function getShowMinimap(): boolean {
  try {
    return localStorage.getItem(MINIMAP_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setShowMinimap(value: boolean): void {
  try {
    localStorage.setItem(MINIMAP_KEY, value ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

/** Whether the dot grid is shown by default. Defaults to true. */
export function getShowGrid(): boolean {
  try {
    return localStorage.getItem(GRID_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setShowGrid(value: boolean): void {
  try {
    localStorage.setItem(GRID_KEY, value ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

/** Whether nodes snap to the grid while dragging. Defaults to false. */
export function getSnapToGrid(): boolean {
  try {
    return localStorage.getItem(SNAP_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setSnapToGrid(value: boolean): void {
  try {
    localStorage.setItem(SNAP_KEY, value ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}
